import { motion } from "framer-motion";
import { Flame } from "lucide-react";
import { FAQ } from "@/data/content";

const EASE = [0.16, 1, 0.3, 1];

export default function Faq() {
  return (
    <section id="faq" className="relative overflow-hidden border-t border-amber-500/10 px-6 py-24 sm:px-10 lg:px-16 lg:py-32">
      <div
        aria-hidden="true"
        className="pointer-events-none absolute -right-40 top-0 h-[400px] w-[400px] rounded-full bg-ember/10 blur-[140px]"
      />
      <div className="relative mx-auto max-w-3xl">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease: EASE }}
          className="mb-12"
        >
          <p className="mb-3 font-mono text-xs uppercase tracking-[0.35em] text-gold">
            Good To Know
          </p>
          <h2 className="bg-gradient-to-r from-amber-100 via-gold to-ember bg-clip-text font-serif text-2xl uppercase tracking-tight text-transparent sm:text-3xl lg:text-4xl">
            Questions Around the Fire
          </h2>
        </motion.div>

        <div>
          {FAQ.map((item, i) => (
            <motion.div
              key={item.q}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: i * 0.08, ease: EASE }}
              className="group border-b border-amber-500/15 py-8 first:pt-0 last:border-b-0"
              data-testid={`faq-item-${i + 1}`}
            >
              <h3 className="flex items-start gap-3 font-serif text-lg text-amber-100 sm:text-xl">
                <Flame className="mt-1 size-4 shrink-0 text-ember" strokeWidth={1.5} />
                {item.q}
              </h3>
              <p className="mt-3 pl-7 text-sm leading-relaxed text-neutral-300 sm:text-base">
                {item.a}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
